/**
 * Shared formatters + tiny UI primitives for the Referral CRM (iter 170 split).
 *
 * Everything in here is pure — no state, no fetch, no side effects — so it
 * can be freely imported by ``AdminReferralCrm`` + every tab component.
 */
export function slugify(s) {
  return String(s || '').replace(/\s+/g, '-').toLowerCase();
}

export function fmtPct(v) {
  return v == null ? '—' : `${Math.round(v * 100)}%`;
}

export function fmtHours(v) {
  if (v == null) return '—';
  if (v < 1) return `${Math.round(v * 60)}m`;
  if (v < 48) return `${v.toFixed(1)}h`;
  return `${Math.round(v / 24)}d`;
}

export function relTime(iso) {
  if (!iso) return '';
  try {
    const min = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
    if (min < 1) return 'just now';
    if (min < 60) return `${min}m ago`;
    const hr = Math.round(min / 60);
    if (hr < 24) return `${hr}h ago`;
    const day = Math.round(hr / 24);
    if (day < 30) return `${day}d ago`;
    return new Date(iso).toLocaleDateString();
  } catch { return ''; }
}

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
